module.exports = __webpack_public_path__ + "static/media/logo.407b25fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.png
// module id = 563
// module chunks = 0